
import { Options, prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import OverlayPanel from "primevue/overlaypanel";
import { on } from "events";
import { formatByCountry, parseByCountry } from "@/app/infrastructures/misc/Utils";

class Props {
  formType = prop<any>({
    default: "",
    type: String
  });
  totalItem = prop<any>({
    default: "0"
  });
  totalGrossWeight = prop<any>({
    default: "0"
  });
  totalDimensionWeight = prop<any>({
    default: "0"
  });
  totalVolumeWeight = prop<any>({
    default: "0"
  });
  chargeableWeight = prop<any>({
    default: "0"
  });
  isCampaign = prop<boolean>({
    required: true
  });
  id = prop<string>({
    default: "",
    type: String
  });
  clientCountry = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["updateStatusErrorEmbargo"],
  components: { OverlayPanel }
})
export default class WeightCost extends Vue.with(Props) {
  isShow = false;

  get dataProfile() {
    return AccountController.accountData;
  }

  formatWeight(value: number | string) {
    return formatByCountry(Number(value), {
      type: "weight",
      country: this.clientCountry
    });
  }

  showDownloadChoice() {
    this.isShow = !this.isShow;
  }

  onCloseAnywhere(value: boolean) {
    this.isShow = value;
  }

  isMouseDown = false;
  onFocusTrigger(event: any) {
    if (this.isMouseDown) return;

    this.toggleTooltip(event);
  }
  onKeydownTrigger(e: KeyboardEvent) {
    const refs: any = this.$refs;
    const tooltip = refs["opTooltipWeightCost"];

    if (e.key === "Escape" || e.key === "ArrowDown") {
      this.isShow = false;
      tooltip?.hide(e);
      e.preventDefault();
      return;
    }

    if (e.key === "ArrowUp") {
      this.isShow = true;
      tooltip?.show(e);
      e.preventDefault();
      return;
    }
  }

  toggleTooltip(event: any) {
    this.showDownloadChoice();
    const refs: any = this.$refs;
    refs["opTooltipWeightCost"].toggle(event);
  }

  hideToggle(event: any) {
    const refs: any = this.$refs;
    refs["opTooltipWeightCost"].hide(event);
    this.isShow = false;
  }

  get isGrossWeight() {
    const x = this.parseNumber(this.totalGrossWeight);
    const y = this.parseNumber(this.totalVolumeWeight);
    return x > y;
  }

  get isVolumeWeight() {
    const x = this.parseNumber(this.totalGrossWeight);
    const y = this.parseNumber(this.totalVolumeWeight);
    return x < y;
  }

  formatNumber(value: string) {
    return formatByCountry(
      this.parseNumber(value), 
      { 
        type: "weight",
        country: this.accountCountryCode,
        suffix: " kg"
      }
    );
  }

  parseNumber(val: string) {
    return parseByCountry(val, {
      country: this.accountCountryCode,
    });
  }

  get accountCountryCode() {
    return AccountController.accountData.countryCode?.toUpperCase();
  }
}
